<template>
  <div class="_plan_item">
    <div class="plan_item_advertisement">
      <!-- <img :src="banner" /> -->
      <!-- <img src="https://www.7859888tp.com/750-50.gif" /> -->
    </div>
    <p class="plan_item_title">
      <span class="blink2 fs4">【彩霸王】 【家野三肖】</span>
    </p>
    <ul class="fs3">
        <li class="color2 fs3">家禽：牛狗猪马羊  野兽：龙兔蛇鼠猴虎</li>
      <li
        v-for="(el, i) in data.list"
        :key="i"
        :class="{
          li_win:
            el.yuCe.jia.includes(el.shengXiao) ||
            el.yuCe.ye.includes(el.shengXiao),
        }"
      >
        <span class="qi">{{ el.qiShu }}期: </span>
        <!-- <span class="name">单双二肖</span> -->
        <div
          :class="{
            suck: isWin(el),
          }"
        >
          <div class="value">
            【 <span class="color3">家:</span>
            <span v-for="(num, numIndex) in el.yuCe.jia" :key="numIndex">
              <span :class="{ win: num === el.shengXiao }">{{
                num.yuCe || num
              }}</span> </span
            >&nbsp <span class="color3">野:</span>
            <span v-for="(num, numIndex) in el.yuCe.ye" :key="numIndex">
              <span :class="{ win: num === el.shengXiao }">{{
                num.yuCe || num
              }}</span> </span
            >】
          </div>
        </div>
        <span class="winText" v-if="el.ifZuiXin">等开</span>
        <span class="winText" v-else
          >开：{{ getNumSx(el.code, el.qiShu) }} {{ el.code
          }}{{
            el.yuCe.jia.includes(el.shengXiao) ||
            el.yuCe.ye.includes(el.shengXiao)
              ? "准"
              : "错"
          }}</span
        >
      </li>
    </ul>
  </div>
</template>
      
      <script setup>
import top from "@/assets/img/top.gif";
import { toRefs } from "vue";
import { getNumSx } from "@/utils";

function jsonp(data) {
  return JSON.parse(data);
}

function isWin(el) {
  return (
    !el.yuCe.jia.includes(el.shengXiao) &&
    !el.yuCe.ye.includes(el.shengXiao) &&
    !el.ifZuiXin
  );
}

const props = defineProps({
  data: Object,
});

const { data } = toRefs(props);
</script>
      
      <style lang="scss" scoped>
.title {
  text-align: center;
  background-color: #009788;
  font-size: 25px;
  font-weight: bold;
  padding: 6px 0;
}
._plan_item {
  border: 1px solid #009788;
  .plan_item_advertisement {
    img {
      width: 100%;
      height: 40px;
      display: block;
    }
  }
  .plan_item_title {
    font-weight: bold;
    text-align: center;
    background: #3e73fe;
    padding: 3px 0;
    color: #fff !important;
    img {
      width: 30px;
      height: 30px;
    }
  }
  ul {
    background-color: #eee;
    li {
      text-align: center;
      padding: 5px 30px;
      font-weight: bold;
      display: flex;
      justify-content: center;
      .value {
        color: #0000ff;
        .win {
          background-color: #ffff00;
          color: red;
        }
      }
      &:not(:last-child) {
        border-bottom: 2px solid #d2d2d2;
      }
    }
    .li_win {
      .winText {
        color: #309631;
      }
    }
    .suck {
      text-decoration-line: line-through;
    }
  }
}
.tip {
  text-align: center;
  margin: 8px 0;
  font-weight: bold;
  display: flex;
  justify-content: space-around;
}
</style>